export const moxieMarketsAppBaseURL =
    import.meta.env.VITE_MOXIE_MARKET_APP_BASE_URL !== undefined
        ? import.meta.env.VITE_MOXIE_MARKET_APP_BASE_URL
        : 'http://localhost:5173'

export const publicApiBaseURL =
    import.meta.env.VITE_PUBLIC_API_BASE_URL !== undefined
        ? import.meta.env.VITE_PUBLIC_API_BASE_URL
        : 'http://localhost:5250'

export const marketDataApiBaseURL =
    import.meta.env.VITE_MARKET_DATA_API_BASE_URL !== undefined
        ? import.meta.env.VITE_MARKET_DATA_API_BASE_URL
        : 'http://localhost:5250'
